import React, { createContext, useContext } from 'react';

import { PrivatePensionEntityNormalized } from '../../../../../../../store/product/types';

interface PrivatePensionAssetContextReceivedData {}

type PrivatePensionEntityNormalizedWithAccountId = PrivatePensionEntityNormalized & {
  accountId: number;
};

interface PrivatePensionAssetContextData extends PrivatePensionAssetContextReceivedData {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  offerSelected: PrivatePensionEntityNormalizedWithAccountId | undefined;
  setOfferSelected: React.Dispatch<
    React.SetStateAction<PrivatePensionEntityNormalizedWithAccountId | undefined>
  >;
}

interface Props extends PrivatePensionAssetContextReceivedData {
  children: React.ReactNode;
}

const PrivatePensionAssetContext = createContext<PrivatePensionAssetContextData>(
  {} as PrivatePensionAssetContextData
);

const PrivatePensionAssetProvider: React.FC<Props> = ({ children, ...props }) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [offerSelected, setOfferSelected] =
    React.useState<PrivatePensionEntityNormalizedWithAccountId>();

  return (
    <PrivatePensionAssetContext.Provider
      value={{
        ...props,
        modalOpen,
        setModalOpen,
        offerSelected,
        setOfferSelected,
      }}>
      {children}
    </PrivatePensionAssetContext.Provider>
  );
};

const usePrivatePensionAssetContext = (): PrivatePensionAssetContextData => {
  const context = useContext(PrivatePensionAssetContext);

  if (!context) {
    throw new Error(
      'usePrivatePensionAssetContext must be used within an PrivatePensionAssetContext'
    );
  }
  return context;
};

export {
  PrivatePensionAssetProvider,
  usePrivatePensionAssetContext,
  PrivatePensionAssetContextData,
};
